import { Component, Output, EventEmitter, ViewChildren,
  OnInit, OnChanges, SimpleChanges, QueryList, Input } from '@angular/core';
import { Parametric } from './parametric.model';
import { IFilterOption, ExpansorWithChipComponent,
  ISelectedValue } from '../shared-components/expansor-with-chip/expansor-with-chip.component';
import { MediaService } from '../shared-services/media.service';
import { ApiService } from '../core/api.service';
import { ExpansorWithChipMultipleComponent, IOption } from '../shared-components/expansor-with-chip-multiple/expansor-with-chip-multiple.component';
import { Tag } from './tag.model';
import { ExpansorWithSearchComponent } from '../shared-components/expansor-with-search/expansor-with-search.component';
import { Provincia } from './provincia.model';
import { Pais } from '../security/user/pais.model';
import * as moment from 'moment';

export interface ISelectedChip {
  chipKey: string;
  chipLabel: string;
  categoryName: string;
  tagId: any;
  selectedChipFilterComponent: any; // Componente del viewChild
}

export interface DocChangeResponse {
  selectedChips: ISelectedChip[];
  selectedDocs: Parametric[];
}

export interface GenericFilter {
  id: number;
  label: string;
  selected: boolean;
  filter: string;
}


@Component({
  selector: 'app-cliente-filter',
  styleUrls: ['./cliente-filter.component.scss'],
  templateUrl: './cliente-filter.component.html',
})
export class ClienteFilterComponent implements OnInit, OnChanges {
  isMobile: boolean;

  ultimaConexion: string;
  ultimoPedido: string;
  paisBuscado: string; 

  @Input() showEstado = true;
  @Input() selectedChips: ISelectedChip[] = [];

  ultimaConexionFilterValues: IFilterOption[] = [];
  ultimoPedidoFilterValues: IFilterOption[] = [];
  paisFilterValues: IFilterOption[] = [];
  origenFilterValues: IFilterOption[] = [];

  @ViewChildren('ultimaConexionFilter') private ultimaConexionFilterComponent: ExpansorWithChipComponent;
  @ViewChildren('ultimoPedidoFilter') private ultimoPedidoFilterComponent: ExpansorWithChipComponent;
  @ViewChildren('paisFilter') private paisFilterComponent: ExpansorWithChipComponent;
  @Output() onFilterChange = new EventEmitter<ISelectedChip[]>();
  @Output() onHide = new EventEmitter<void>();

  async getUltimaConexionValues () {
    this.ultimaConexionFilterValues.push({value: this.getFechaReciente(), displayText: 'Reciente', class: ''});
    this.ultimaConexionFilterValues.push({value: this.getFechaHacePoco(), displayText: 'Hace poco', class: ''});
    this.ultimaConexionFilterValues.push({value: this.getFechaHaceMucho(), displayText: 'Hace mucho', class: ''});
  }
  async getUltimoPedidoValues () {
    this.ultimoPedidoFilterValues.push({value: this.getFechaReciente(), displayText: 'Reciente', class: ''});
    this.ultimoPedidoFilterValues.push({value: this.getFechaHacePoco(), displayText: 'Hace poco', class: ''});
    this.ultimoPedidoFilterValues.push({value: this.getFechaHaceMucho(), displayText: 'Hace mucho', class: ''});
  }

  async getPaisBuscadoValues () {
    this.paisFilterValues.push({value: this.getPaisArgentina(), displayText: 'Argentina', class: ''});
    this.paisFilterValues.push({value: this.getPaisChile(), displayText: 'Chile', class: ''});
  }

  constructor(
    private mediaService: MediaService,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.mediaService.isMobile.subscribe(isMobile => this.isMobile = isMobile);
    this.getUltimaConexionValues();
    this.getUltimoPedidoValues();
    this.getPaisBuscadoValues();
  }

  ngOnChanges(changes: SimpleChanges) {}

  onRemoveChip(selectedChip: ISelectedChip) {
    selectedChip.selectedChipFilterComponent.onRemoveChip();
    this.selectedChips = this.selectedChips.filter(x => x.chipKey !== selectedChip.chipKey);
    this.filterChange();
  }

  onUltimaConexionChange(selectedFilter: ISelectedValue) {
    this.addChip('ultimaConexionFilter', selectedFilter.viewValue, selectedFilter, this.ultimaConexionFilterComponent);
    this.ultimaConexion = selectedFilter.value;
    this.filterChange();
  }

  onUltimoPedidoChange(selectedFilter: ISelectedValue) {
    this.addChip('ultimoPedidoFilter', selectedFilter.viewValue, selectedFilter, this.ultimoPedidoFilterComponent);
    this.ultimoPedido = selectedFilter.value;
    this.filterChange();
  }

  onBusquedaPaisChange(selectedFilter: ISelectedValue) {
    this.addChip('paisFilter', selectedFilter.viewValue, selectedFilter, this.paisFilterComponent);
    this.paisBuscado = selectedFilter.value;
    this.filterChange();
  }

  addMultipleChip(chips: any[], categoryName: string, chipName: string, component: ExpansorWithChipMultipleComponent<Tag>) {
    this.selectedChips = this.selectedChips.filter(x => x.categoryName !== categoryName);

    for (const chip of chips) {
      const chipKey = chipName + chip.value;

      if (!this.selectedChips.find(x => x.chipKey === chipKey)) {
        const selectedFilter = { value: chip.value, categoryName: categoryName, viewValue: chip.displayText };
        this.addChip(chipKey, chip.displayText, selectedFilter, component);
      }
    }
  }

  filterChange() {
    this.onFilterChange.emit(this.selectedChips);
  }

  addChip(chipKey: string, chipLabel: string, selectedFilter: ISelectedValue, selectedChipFilterComponent: any): ISelectedChip {
    if (selectedFilter.value === undefined) {
      return;
    }

    if (this.selectedChips.find(x => x.chipKey === chipKey)) {
      return;
    }

    const selectedChipInstance: ISelectedChip =  {
      chipKey: chipKey,
      chipLabel: chipLabel,
      categoryName: selectedFilter.categoryName,
      tagId: selectedFilter.tagID !== undefined ? selectedFilter.tagID : selectedFilter.value,
      selectedChipFilterComponent: (<QueryList<ExpansorWithChipComponent>>selectedChipFilterComponent).first
    };

    this.selectedChips.push(selectedChipInstance);
  }

  onTogglePickerFrom(event: any) {
    event.stopPropagation();
  }

  onTogglePickerTo(event: any) {
    event.stopPropagation();
  }

  getFechaReciente() {
    return 3;
  }

  getFechaHacePoco() {
    return 15;
  }
  getFechaHaceMucho() {
    return 60;
  }

  getPaisArgentina () {
    return 55;
  }

  getPaisChile () {
    return 63;
  }

  getFecha(val: number) {
    const d = new Date();
    d.setDate(new Date().getDate() - val);
    return moment(d).format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-filter.component.ts